module.exports = __webpack_public_path__ + "static/mha-8576d00bcf91adfb8ebaf0c167890704.png";